<template>
  <Drawer
    v-model:visible="visible"
    :header="header"
    :modal="true"
    :closable="true"
    :position="'bottom'"
    :style="{ width: '80vw', height: 'auto' }"
    class="pb-6"
  >
    <div class="flex flex-col gap-2">
      <div class="flex items-center w-full justify-center">
        <!--<Inplace>
          <template #display> {{ value }} mins </template>
          <template #content="{ closeCallback }">
            <span class="inline-flex items-center gap-2">
              <InputText
                id="impact-input"
                v-model.number="value"
                @blur="(event) => (value = Math.round(event.target.value / 15) * 15)"
              />
              <Button icon="pi pi-times" text severity="danger" @click="closeCallback" />
            </span>
          </template>
        </Inplace>-->
      </div>

      <label for="impact-slider" class="text-sm text-gray-500 mb-2">
        {{ props.increase ? 'Increase' : 'Decrease' }} Screen Time by {{ value }} mins
      </label>
      <Slider id="impact-slider" v-model="value" :step="15" :max="120" class="mb-4" />

      <div class="grid-cols-[1fr_50px] grid gap-2 items-center">
        <AutoComplete
          v-model="reason"
          :suggestions="suggestions"
          placeholder="Reason.."
          @complete="search"
          pt:pcInputText:root="!m-2 !rounded-full !h-10"
          fluid
        />
        <div class="flex flex-row items-center gap-2">
          <i class="pi pi-star text-gray-500 cursor-pointer" />
          <Checkbox
            v-model="favourite"
            binary
            :label="'Add to favorites'"
            :true-value="true"
            :false-value="false"
            class="text-sm text-gray-500 cursor-pointer"
          />
        </div>
      </div>
    </div>

    <Button
      label="Save"
      :disabled="value !== 0 && reason.length === 0"
      icon="pi pi-check"
      class="!mt-4 !rounded-full !h-10"
      fluid
      @click="handleSave"
    />
    <div class="flex flex-row flex-wrap items-center justify-between gap-2 pt-4">
      <Chip
        v-for="reason in commonReasons.slice(0, 6)"
        :key="reason.id"
        class="text-xs"
        :label="`${reason.description}`"
        @click="updateCommon(reason)"
      />
    </div>
  </Drawer>
</template>
<script setup lang="ts">
  import InputText from 'primevue/inputtext'
  import Slider from 'primevue/slider'
  import Child from '../store/models/Child'
  import { useImpactReason } from './composables/useImpactReason'
  import { computed, Ref, ref } from 'vue'
  import Button from 'primevue/button'
  import Inplace from 'primevue/inplace'
  import Drawer from 'primevue/drawer'
  import AutoComplete from 'primevue/autocomplete'
  import ImpactReason from '../store/models/ImpactReason'
  import Checkbox from 'primevue/checkbox'
  import ScreenTimeEvent from '../store/models/ScreenTimeEvent'
  import { useRepo } from 'pinia-orm'
  import { describe } from 'node:test'
  import { Chip, Divider } from 'primevue'
  import { label } from '@primeuix/themes/aura/metergroup'

  const visible = defineModel<boolean>('visible')
  const props = defineProps<{
    child: Child | null
    increase: boolean
    screenTime: number
  }>()

  const value = ref(0) as Ref<number>
  const reason = ref('') as Ref<string>
  const favourite = ref(false) as Ref<boolean>
  const suggestions = ref([]) as Ref<string[]>

  const screenTimeRepo = useRepo(ScreenTimeEvent)

  const header = computed(() => {
    return `${props.child?.name}: ${props.increase ? 'Increase' : 'Decrease'}`
  })

  const { increases, decreases, impactRepo, commonDecreases, commonIncreases } = useImpactReason(
    props.child
  )

  const reasons = computed(() => {
    return (props.increase ? increases.value : decreases.value).map((reason) => {
      return reason.description
    })
  }) as Ref<string[]>

  const commonReasons = computed(() => {
    return props.increase ? commonIncreases.value : commonDecreases.value
  })

  const search = (event: any) => {
    const query = event.query.toLowerCase()
    suggestions.value = reasons.value.filter((reason) => reason.toLowerCase().includes(query))
  }

  const handleSave = () => {
    if (props.child) {
      // if favourite is true, add to favourites if not already in the list
      if (favourite.value && !reasons.value.includes(reason.value)) {
        impactRepo.save({
          childId: props.child.id,
          description: reason.value,
          isIncrease: props.increase,
        })
      }
      // save screen time impact
      if (value.value !== 0 && reason.value.length > 0) {
        const impact = props.increase ? +value.value : -value.value

        screenTimeRepo.save({
          childId: props.child.id,
          timestamp: new Date(),
          impact,
          description: reason.value,
          timeBefore: props.screenTime,
          timeAfter: props.screenTime + impact,
        })
      }
      // reset values
      value.value = 0
      reason.value = ''
      favourite.value = false
      visible.value = false
    }
  }

  const updateCommon = (selectedReason) => {
    value.value = selectedReason.impact * (props.increase ? 1 : -1)
    reason.value = selectedReason.description
    favourite.value = false
  }
</script>
